import { Component, Input } from "@angular/core";
import { Breadcrumb } from "src/app/models/breadcrumb.model";
import { MatIcon } from "@angular/material/icon";
import { RouterLink } from "@angular/router";
import { ExtendedModule } from "@angular/flex-layout/extended";
import { NgIf, NgClass, NgFor } from "@angular/common";

@Component({
    selector: "app-common-breadcrumbs",
    templateUrl: "./common-breadcrumbs.component.html",
    styleUrls: ["./common-breadcrumbs.component.scss"],
    imports: [NgIf, NgClass, ExtendedModule, RouterLink, MatIcon, NgFor]
})
export class CommonBreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumb[];
  @Input() homeIcon: boolean = false;

  constructor() {}
}
